// extracted by mini-css-extract-plugin
export default {"cta-box":"style_cta-box__kt+HR"};